import { reportType } from '@bingads-webui-campaign/reports-v4-strings';

export default ({ i18n }) => ({
  key: 'report-base',
  name: i18n.getString(_TL_('Report base')),
  fieldName: 'ReportType',
  minWidth: 100,
  maxWidth: 250,
  isResizable: true,
  sortable: true,
  data: 'number',
  onRender: item => (reportType[item.ReportType] ? i18n.getString(reportType[item.ReportType]) : item.ReportType),
});
